import React, { useEffect, useState } from "react";
import { Col, message, Row } from "antd";
import ColdStorageChart1 from "./components/cold_storage_1";
import ColdStorageChart2 from "./components/cold_storage_2";
import ColdStorageChart3 from "./components/cold_storage_3";
import API from "../../../services/api-request";
import dayjs from "dayjs";
import UserManualButton from "../../../components/UserManualButton";

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const getDataTemperature = () => {
    API.Post(`dashboard/report`, {
      date: dayjs().format("YYYY-MM-DD"),
    })
      .then((result) => {
        const data = result?.data?.data;

        const merged = Object.values(
          data.reduce((acc, curr) => {
            if (!acc[curr.name]) {
              acc[curr.name] = {
                name: curr.name,
                TemperatureDoorStatuses: [],
              };
            }

            acc[curr.name].TemperatureDoorStatuses.push(
              ...curr.TemperatureDoorStatuses
            );
            return acc;
          }, {})
        );

        setData(merged);
      })
      .catch((error) => {
        console.log(error);
        message.info("Failed Fetch Report");
      });
  };

  useEffect(() => {
    getDataTemperature();
  }, []);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <div
          style={{
            width: "fit-content",
            marginLeft: "auto",
          }}
        >
          <UserManualButton />
        </div>
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        <ColdStorageChart1 data={data?.[5]} />
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        <ColdStorageChart2 data={data?.[4]} />
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        <ColdStorageChart3 data={data?.[3]} />
      </Col>
    </Row>
  );
};

export default Reports;
